import { render } from "./FeedbackComponent.vue?vue&type=template&id=5e527f34"
import script from "./FeedbackComponent.vue?vue&type=script&lang=js"
export * from "./FeedbackComponent.vue?vue&type=script&lang=js"

import "./FeedbackComponent.vue?vue&type=style&index=0&id=5e527f34&lang=scss"

import exportComponent from "/builds/ASIP-Sante/g1/shared/santefr/web/modules/custom/sante_vuejs/vue-core/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sharedComponents/FeedbackComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5e527f34"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5e527f34', __exports__)) {
    console.log('reload')
    api.reload('5e527f34', __exports__)
  }
  
  module.hot.accept("./FeedbackComponent.vue?vue&type=template&id=5e527f34", () => {
    console.log('re-render')
    api.rerender('5e527f34', render)
  })

}


export default __exports__